import { getCurrentCountry, getCurrentDomainForCookies } from "./BasePathTools";

export function createCookie(
  name: string,
  value: any,
  maxAge?: number,
  expires?: string,
) {
  const domain = getCurrentDomainForCookies();
  const path = `/${getCurrentCountry()}`;
  const sameSite = "none";
  const secure = true;
  const cookieParts = [
    `${name}=${value}`,
    `Domain=${domain}`,
    `path=${path}`,
    `SameSite=${sameSite}`,
    secure ? "Secure" : "",
    maxAge ? `max-age=${maxAge}` : "",
    expires ? `expires=${expires}` : "",
  ].filter(Boolean);
  document.cookie = cookieParts.join("; ");
}

export const getValueCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';')[0] || null;
  }
  return null;
};

export const getCookie = (name: string): string[] => {
  const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`));
  
  if (cookieValue) {
    try {
      return JSON.parse(decodeURIComponent(cookieValue.split('=')[1]));
    } catch (e) {
      return [];
    }
  }
  return [];
};

export function removeCookie(name: string): void {
  const exp = new Date(0).toUTCString();
  createCookie(name, "", 0, exp);
}
